/**
 * Utility helpers for articles (reading time, plain text extraction, related).
 */

export const stripHtml = (html) => {
  if (!html) return "";
  if (typeof window === "undefined") return html.replace(/<[^>]*>/g, "");
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

export const readingTime = (content) => {
  const text = stripHtml(content);
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.round(words / 200));
  return minutes;
};

export const isHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(str || "");

export const excerptFromContent = (content, maxLen = 160) => {
  const text = stripHtml(content).replace(/\s+/g, " ").trim();
  return text.length > maxLen ? text.slice(0, maxLen).trim() + "..." : text;
};

export const relatedArticles = (all, current, limit = 3) => {
  if (!all || !current) return [];
  const others = all.filter((a) => a.slug !== current.slug && a.published !== false);
  const catOf = (v) => (v && typeof v === "object" ? (v.id || v.en || "") : String(v || ""));
  const currentTags = new Set(current.tags || []);
  const currentCat = catOf(current.category);
  const scored = others.map((a) => {
    let score = 0;
    if (catOf(a.category) === currentCat) score += 3;
    (a.tags || []).forEach((t) => { if (currentTags.has(t)) score += 1; });
    return { a, score };
  });
  scored.sort((x, y) => y.score - x.score);
  const picked = scored.slice(0, limit).map((s) => s.a);
  if (picked.length < limit) {
    const rest = others.filter((o) => !picked.includes(o));
    return [...picked, ...rest].slice(0, limit);
  }
  return picked;
};
